<template>
  <el-dialog
    append-to-body
    width="700px"
    :title="info && info.name ? `${info.name}的开通会员记录` : ''"
    center
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-table
      :data="tableData"
      style="width: 100%"
      max-height="500"
      v-loading="loading"
    >
      <el-table-column type="index" label="序号" width="50" align="center">
      </el-table-column>
      <el-table-column
        prop="create_time"
        label="创建时间"
        width="150"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="show_type"
        label="开通方式"
        width="150"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="address" label="会员有效期">
        <template #default="{ row }">
          <span v-if="row.start_time">{{ row.start_time }} 至 {{ row.end_time }}</span>
          <span v-else>待领取</span>
        </template>
      </el-table-column>
    </el-table>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button @click="toggle(false)">关闭</el-button>
      </el-row>
    </template>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      info: {},
      loading: false,
      tableData: [],
    };
  },
  methods: {
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    getDetail(row) {
      this.info = row;
      this.getData();
    },
    getData() {
      this.loading = true;
      this.$http
        .get("/admin/user/vipLog", {
          params: { page: 1, count: 9999, user_id: this.info.id },
        })
        .then((res) => {
          if (res.code == 1) {
            this.tableData = res.data.list;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    reset(done) {
      this.info = {};
      this.tableData = [];
      done && done();
    },
  },
};
</script>